module.exports = __webpack_public_path__ + "img/logo-北师大.163292cb.svg";